var $ = require('jquery');
var msgbox = require('../common/msgbox.js');
var ajax = require('../common/ajax.js');
var tpl = require('../tpl/vcode.tpl');
var util = require('../common/util.js');
var acturl = "http://dyactive2.vip.xunlei.com/iface/?action=getPrize";
var vcodeId = "act_verify_popbox";
var active_cfg = window.active_cfg;
var actid = '';
var percent = util.getUrlParam('percent') || '';
var pid = util.getUrlParam('pid') || '';
var sign = util.getUrlParam('sign') || '';
var arrParm = window.location.search.split('?').slice(1).join('&') || '';
var issubmit = false;
var user = require('../common/user.js');
var VC = {
    keycode: '',
    show: function(keycode) {
        VC.keycode = keycode;
        if (!haslogin()) {
            login();
            return;
        }
        VC.refresh();
        msgbox.show(vcodeId);
        this.showTips('ok');
    },
    refresh: function() {
        $("#prize_verify").val('');
        $("#prize_verify_img").attr("src", "http://verify2.xunlei.com/image?t=MVA&" + Math.random());
    },
    send: function(gid, url, type) {

        var that = this;
        var code = $("#prize_verify").val();
        var gourl = '';
        if (code == '' && type == 'code') {
            that.showTips("请输入短信验证码");
            $("#prize_verify").focus();
        } else {
            if (issubmit == true) return;
            issubmit = true;
            that.sendBtn(issubmit);
            if (url) {
                gourl = url;
            } else {
                gourl = acturl + "&actid=" + actid + "&gid=" + gid + "&ver_code=" + code + "&" + arrParm;
            }

            if (type == 'check') {
                gourl += '&option=check';
                ajax(gourl, function(rs) {
                    var result = Number(rs.result);
                    issubmit = false;
                    that.sendBtn(issubmit);
                    if (result == 0) {

                        VC.init(gid, url, 'code');
                        VC.show(gid, url, 'code');
                        $('#code-mobile').text(rs.data.mobile);
                    } else {
                        msgbox.showErrorMsg(rs.msg);
                        that.showTips('ok');
                    }

                });
            } else {
                gourl += '&vermobile=' + code;
                ajax(gourl, function(rs) {
                    var result = Number(rs.result);
                    issubmit = false;
                    that.sendBtn(issubmit);
                    if (result == -100) {
                        showErrorMsg(rs.msg);
                    } else if (result == 0) {
                        var codeid = "success_" + rs.data.codeid;
                        var keycode = rs.data.keypwd == "" ? rs.data.keycode : rs.data.keycode + "/" + rs.data.keypwd;
                        $("#" + codeid).find('.keycode').html(keycode);
                        msgbox(rs.msg, {
                            btn_title: '查看奖品',
                            btn_href: 'javascript:;',
                            btn_class: 'act_prize'
                        });
                        loginInit();
                        that.sendCallback(rs);
                        that.showTips('ok');
                    } else if(result == -201){
                        msgbox('您已经领取过该奖品了哦，<a href="javascript:;" class="act_prize">查看我的奖品>></a>');
                    } else {
                        msgbox.showErrorMsg(rs.msg);
                        that.showTips('ok');
                    }
                });
            }

        }
    },
    sendCallback: function(data) {
        if ($.isFunction(window.ACTCONFIG.vcode_sendCallback)) {
            window.ACTCONFIG.vcode_sendCallback(data);
        }
    },
    init: function(gid, url, type) {
        var that = VC;
        if (!$('#' + vcodeId).length) {
            $('body').append(tpl);
        }

        $('#act_send_btn').off('click.submit').on('click.submit', function(event) {
            that.send(gid, url, type);
            return false;
        });
    },
    showTips: function(error) {
        if (error != 'ok') {
            $('#act_error_tips').text(error).show();
        } else {
            $('#act_error_tips').hide()
        }

    },
    sendBtn: function(issubmit) {
        //console.log(issubmit)
        if (issubmit == true) {

            $('#act_send_btn').text('提交中...');
        } else {
            $('#act_send_btn').text('提交');
        }
    },
    run: function(options){
        if (!haslogin()) {
            login();
            return false;
        }

        if (user.isChild()) {
            msgbox('抱歉，您使用的是迅雷子帐号，请使用主帐号来参加活动！');
            return false;
        }

        actid = options.actid || active_cfg.base.actid;
        var keycode = $(this).attr('keycode');

        VC.send(options.gid, options.url, 'check');
    }
};

function showErrorMsg(MSGID) {
    var MSG = active_cfg['msg'][MSGID];
    if (MSG) {
        var opts = {
            btn_title: MSG['btn_text'],
            btn_href: MSG['btn_link'],
            btn_target: MSG['btn_action'],
            boxTitle: MSG['title']
        };
        msgbox(MSG['content'], opts);
    } else {
        msgbox(MSGID);
    }
}

module.exports = VC.run;



//////////////////
// WEBPACK FOOTER
// ./src/tools/vcode.js
// module id = 20
// module chunks = 2